import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { cashService } from '../../services/cashService';
import { Snackbar } from '@scramble/ui';
import i18n from '@/i18n';

const { t } = i18n;

export const useDeleteBankAccount = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: id =>
      cashService
        .deleteBankAccount(id)
        .then(response => {
          const { status, data } = response;
          if (status === 200) {
            Snackbar({
              type: 'success',
              text: t('bank_accounts:common.bank_details_removed'),
            });
            queryClient.invalidateQueries({
              queryKey: [QUERY_KEYS.cash.bank_accounts],
            });
            return { data, success: true };
          }
          throw new Error(data?.message);
        })
        .catch(e => {
          return { success: false, message: e.message };
        }),
  });
};
